/**
 * Phone Glossary dock + A–Z sheet (merchant 2026-11-01, v3). Glossary index only; markup in templates/page.glossary.liquid.
 * - The dock is always on screen on this page (CSS shows it; html[data-gf-dock] hides the chat bubble and pads the page end).
 *   Add a term and Contributors scroll to their sections ("Know a term we're missing" first, so visitors see what it is).
 * - A–Z sheet: letters with no visible group (search / category filter) are greyed; the current letter (scroll-spy in
 *   s-glossary-finder.js marks .gf-letters [data-current]) is marked on open. Tapping a letter closes the sheet, then
 *   jumps to that letter's group.
 */
const dock = document.querySelector('[data-gf-dock]');
const sheet = document.getElementById('gf-az');
const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const jump = (el) => el?.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' });

if (dock) {
  document.documentElement.toggleAttribute('data-gf-dock', true);
  for (const a of dock.querySelectorAll('[data-gf-dock-jump]')) {
    a.addEventListener('click', (e) => {
      e.preventDefault();
      jump(document.querySelector(a.getAttribute('href')));
    });
  }
}

if (sheet) {
  const links = [...sheet.querySelectorAll('[data-gf-az]')];
  const sync = () => {
    const current = document.querySelector('.gf-letters [data-current]')?.dataset.gfLetter;
    for (const a of links) {
      const g = document.getElementById(`letter-${a.dataset.gfAz}`);
      const on = !!g && !g.hidden;
      a.toggleAttribute('data-off', !on);
      a.setAttribute('aria-disabled', String(!on));
      a.tabIndex = on ? 0 : -1;
      if (a.dataset.gfAz === current) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    }
  };
  sync();
  document.querySelector('[commandfor="gf-az"][command="show-modal"]')?.addEventListener('click', sync);
  for (const a of links) {
    a.addEventListener('click', (e) => {
      e.preventDefault();
      if (a.hasAttribute('data-off')) return;
      const g = document.getElementById(`letter-${a.dataset.gfAz}`);
      sheet.close();
      // Wait one frame so the page is scrollable again once the modal has closed.
      requestAnimationFrame(() => jump(g));
    });
  }
}
